import * as weixin from '@ivy/fts/weixin';
// 阿里云图片获取指定尺寸的图片
export function transAliImgResize(url, width, height, mode = 'mfit') {
    return `${url}?x-oss-process=image/resize,${mode},h_${height},w_${width}`;
}
export function compareVersion(v1, v2, compare) {
    v1 = v1 + '';
    v2 = v2 + '';
    let l1 = v1.split('.').length;
    let l2 = v2.split('.').length;
    let maxL = Math.max(l1, l2);
    if (l1 < maxL) {
        let x = new Array(maxL - l1).fill('.0').join('');
        v1 += x;
    }
    if (l2 < maxL) {
        let x = new Array(maxL - l2).fill('.0').join('');
        v2 += x;
    }
    v1 = v1
        .split('.')
        .map(n => n.padEnd(5, '0'))
        .join('');
    v2 = v2
        .split('.')
        .map(n => n.padEnd(5, '0'))
        .join('');
    let n1 = Number(v1);
    let n2 = Number(v2);
    switch (compare) {
        case '>':
            return n1 > n2;
        case '=':
            return n1 === n2;
        case '>=':
            return n1 >= n2;
        case '<':
            return n1 < n2;
        case '<=':
            return n1 <= n2;
        default:
            return n1 > n2;
    }
}
export async function hideWxShare(hideMenu = []) {
    await weixin.wxConfigReady();
    let menulist = [
        'menuItem:share:appMessage',
        'menuItem:share:qq',
        'menuItem:share:weiboApp',
        'menuItem:share:facebook',
        'menuItem:share:QZone',
        'menuItem:share:timeline',
    ];
    wx &&
        wx.hideMenuItems({
            menuList: hideMenu && hideMenu.length > 0 ? hideMenu : menulist,
        });
}
